import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SolvdCircledCheck } from 'src/easyclaim.app.assets/icons/SolvdCircledCheck';

export const FinishedV2 = () => {
	return (
		<>
			<div className="finished-confirmation-icon">
				<SolvdCircledCheck />
			</div>
			<div className="finished-centered-header">
				<h2 className="thanks-title">
					<FormattedMessage id="thanks.headline.first" />
				</h2>
			</div>
			<h3 id="thankYouMessage">
				<FormattedMessage id="thankYou.message" />
			</h3>
		</>
	);
};
